// src/components/NotFoundPage.tsx

import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import configSiteUrls from '../site/configs/configSiteUrls';
import configUrls from '../../config/configUrls';

export const NotFoundPage = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate(configUrls.SITE_HOME);
    };

    return (
        <Container maxWidth="md" style={{ textAlign: 'center', marginTop: '50px' }}>
            <Box bgcolor="warning.main" color="warning.contrastText" p={4} borderRadius={4}>
                <Typography variant="h3" component="h1" gutterBottom>
                    404 - Página Não Encontrada
                </Typography>
                <Typography variant="h6" component="p" gutterBottom>
                    A página que você está procurando não existe ou não foi encontrada.
                </Typography>
                <Button variant="contained" color="primary" onClick={handleGoHome}>
                    Voltar para a Página Inicial
                </Button>
            </Box>
        </Container>
    );
};
